import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchPurchaseDetails } from '../api/products';
import { Box, Typography, Button, CircularProgress } from '@mui/material';

const SuccessfulPurchase = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get session_id from query string
  const params = new URLSearchParams(location.search);
  const sessionId = params.get('session_id');

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const data = await fetchPurchaseDetails(sessionId);
        setDetails(data);
      } catch (err) {
        setError('Could not fetch purchase details.');
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [sessionId]);

  return (
    <Box sx={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 3 }}>
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error" variant="h6">{error}</Typography>
      ) : (
        <Box sx={{ textAlign: 'center', bgcolor: 'background.paper', p: 4, borderRadius: 4, boxShadow: 4, maxWidth: 420 }}>
          <Typography variant="h4" color="primary" fontWeight={700} gutterBottom>Thank you for your purchase!</Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>Your payment was successful. Welcome to the premium experience!</Typography>
          <Box sx={{ my: 2, bgcolor: 'rgba(69,123,157,0.07)', borderRadius: 2, p: 2 }}>
            <Typography variant="subtitle1" fontWeight={600}>Order Details</Typography>
            <Typography variant="body2">Order ID: {details?.orderId || 'N/A'}</Typography>
            <Typography variant="body2">Product: {details?.productName || 'Premium Upgrade'}</Typography>
            <Typography variant="body2">Amount: {details?.amount || '$19.99'}</Typography>
            <Typography variant="body2">Email: {details?.email || 'your@email.com'}</Typography>
          </Box>
          <Button variant="contained" color="primary" sx={{ mt: 2, borderRadius: 999 }} onClick={() => navigate('/products')}>
            Back to Shop
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SuccessfulPurchase; 